import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useParams, useNavigate } from "react-router-dom";
import Cliente from './cliente';
import Aners from './aners';


function Editor() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [responseData, setResponseData] = useState(null);

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        const res = await axios.post(`/api/getoneprocess/${id}`, {
          withCredentials: true,
        });

        console.log(res.data);
        if (res.data.auth === true) {
          setIsAuthenticated(true);
          setUserRole(res.data.nivel);
          setResponseData(res.data); // Supondo que res.data contém os dados necessários
        } else {
          navigate('/login');
        }
      } catch (error) {
        console.error('Erro na autenticação:', error);
        navigate('/login');
      }
    };

    authenticateUser();
  }, [id, navigate]);

  // Renderiza um spinner enquanto verifica a autenticação
  if (!isAuthenticated) {
    return (
      <div style={spinnerStyle}>
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  // Renderiza o componente Aners ou Cliente com base no nível do usuário
  return userRole === "Aners" ? (
    <Aners response={responseData} />
  ) : (
    <Cliente response={responseData} />
  );
}

// Estilo para o spinner de carregamento
const spinnerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};

export default Editor;